export default __webpack_public_path__ + "static/media/mech.d1614c2e.png";